import "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/core-js/modules/es.array.iterator.js";
import "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/core-js/modules/es.promise.js";
import "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/core-js/modules/es.object.assign.js";
import "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/core-js/modules/es.promise.finally.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import Vue from 'vue';
import Cookies from 'js-cookie';
// import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/styles/index.scss'; // global css

import App from './App';
import store from './store';
import router from './router';
import '@/icons'; // icon
// 权限指令
import './permission'; // permission control
import '@/components/Form';
import * as filters from './filters'; // global filters
import * as colorUtils from './utils/colorUtils'; // color utilities

// register global utility filters.
Object.keys(filters).forEach(function (key) {
  Vue.filter(key, filters[key]);
});

// register global color utilities
Vue.prototype.$colorUtils = colorUtils;
import VueCoreVideoPlayer from 'vue-core-video-player';
Vue.use(VueCoreVideoPlayer);

// print
import PrintPlugin from '@/vendor/print';
Vue.use(PrintPlugin);

// Vue.use(permission)
Vue.use(ElementUI, {
  size: Cookies.get('size') || 'small',
  theme: Cookies.get('theme') || '#1890FF'
});
Vue.config.productionTip = false;
new Vue({
  el: '#app',
  router: router,
  store: store,
  render: function render(h) {
    return h(App);
  }
});